export default "__VITE_ASSET__f6f0566a__"